import { Link } from './components/Link'

/**
 * Class used by react router NavLink component for active link
 */
export const navLinkStyles = {
  '.product-global-nav-link-active':
    Link.variants['product-global-nav-link-active'],
} satisfies Partial<{
  [Key in keyof typeof Link.variants as `.${Key}`]: (typeof Link.variants)[Key]
}>

export const navLinkClassName = {
  'product-global-nav-link-active': 'product-global-nav-link-active',
} satisfies Partial<{
  [Key in keyof typeof Link.variants]: Key
}>
